import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IntegralGoodsList from "../../../components/Integral/IntegralGoodsList";
import { triggerLoaded } from "@/components/LoadContainer.vue";
export default {
  name: "MemberIntegralSurvey",
  components: {
    IntegralGoodsList: IntegralGoodsList
  },
  computed: {
    intlist: function intlist() {
      return [{
        title: "\u5F53\u524D".concat(this.$store.state.commonSetting.point_info.point_name || ""),
        change_price: this.info.current,
        imgsrc: require("@/assets/images/integral/current-integral.png")
      }, {
        title: "\u5DF2\u6D88\u8017".concat(this.$store.state.commonSetting.point_info.point_name || ""),
        change_price: this.info.total - this.info.current,
        imgsrc: require("@/assets/images/integral/used-integral.png")
      }, {
        title: "\u672C\u6708".concat(this.$store.state.commonSetting.point_info.point_name || ""),
        change_price: this.info.monthly,
        imgsrc: require("@/assets/images/integral/month-integral.png")
      }];
    }
  },
  data: function data() {
    return {
      courses: [],
      goodss: [],
      sign_img: {
        default: require("@/assets/images/integral/sign-default.png"),
        active: require("@/assets/images/integral/sign-active.png")
      },
      signInfo: {},
      info: {
        current: 0,
        monthly: 0,
        total: 0
      }
    };
  },
  methods: {
    getList: function () {
      var _getList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(type) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$http.get("/api/integral/shop/index", {
                  type: type
                });

              case 2:
                data = _context.sent;

                if (type == 1) {
                  if (data.data.length > 3) {
                    data.data = data.data.slice(0, 3);
                  }

                  this.courses = data.data;
                } else {
                  if (data.data.length > 4) {
                    data.data = data.data.slice(0, 4);
                  }

                  this.goodss = data.data;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getList(_x) {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    getInfo: function () {
      var _getInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.get("/api/app/user/integral");

              case 2:
                this.info = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }(),
    // 签到
    getSign: function () {
      var _getSign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$http.get("/api/app/user/integral/isSign");

              case 2:
                this.signInfo = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSign() {
        return _getSign.apply(this, arguments);
      }

      return getSign;
    }(),
    onSign: function onSign() {
      var _this = this;

      if (this.signInfo.is_sign == 1) {
        return;
      }

      this.$http.post("/api/app/user/integral/sign").then(function () {
        _this.$success("签到成功");

        _this.getSign();

        _this.getInfo();
      });
    },
    changeTab: function changeTab(val, type) {
      this.$emit("changeTab", val, type);
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Promise.all([this.getList(1), this.getList(2), this.getInfo(), this.getSign()]);

            case 2:
              triggerLoaded(this);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};